import { render } from "./BulletPointList.vue?vue&type=template&id=6249511a&scoped=true"
import script from "./BulletPointList.vue?vue&type=script&lang=js"
export * from "./BulletPointList.vue?vue&type=script&lang=js"

import "./BulletPointList.vue?vue&type=style&index=0&id=6249511a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6249511a"]])

export default __exports__